export default __webpack_public_path__ + "static/media/Belt of Rapturous Battle.88b8f828.jpg";